module.exports = __webpack_public_path__ + "static/media/loading.5dace8da.gif";